export const ILISKI_MECNUN = [
  {
    id: "imec001",
    metin: "{{ad}}, kırk ülkede ilişki enerjisi okudum. Bu iki insanın arasındaki bağ bana Uzak Doğu felsefesindeki 'kırmızı ip' efsanesini hatırlattı — iki ruhu birbirine bağlayan görünmez bir ip. {{soru}} konusunda şunu söyleyeyim: bu bağ koşullar ne olursa olsun devam ediyor. Ama bağ tek başına yetmez, bakım ister.\n\nBu ilişkiyi besleyin. Her gün küçük bir şey — bir söz, bir bakış, bir jest. Büyük aşklar büyük jestlerle değil, küçük ama tutarlı özenle yaşatılır.",
    tema: "bag"
  },
  {
    id: "imec002",
    metin: "{{ad}}, Hint felsefesinde ilişkiler karma bağları olarak değerlendirilir — geçmiş hayatlardan gelen bir bağlantı. {{soru}} konusunda bu iki insan birbirinde tanıdık bir şey hissediyor mu? O his tesadüf değil.\n\nKarma bağları hem güçlü hem öğreticidir. Bu ilişki size ne öğretiyor? O dersi görmek, ilişkiyi bambaşka bir boyuta taşır. Öğrenmeye açık olun.",
    tema: "karma"
  },
  {
    id: "imec003",
    metin: "{{ad}}, Roma'da bir bilge şöyle derdi: 'İki insan birbirine ayna olur — güzeli de çirkini de gösterir.' {{soru}} konusunda bu iki insan birbirinde ne görüyor?\n\nBeğenmedikleri özellik genellikle kendi içlerinde sakladıklarıdır. Bu zor bir gerçek ama özgürleştirici. Karşınızdakini eleştirmeden önce 'bu bende de var mı?' diye sorun. Cevap sizi şaşırtabilir.",
    tema: "ayna"
  },
  {
    id: "imec004",
    metin: "{{ad}}, Çin felsefesinde ilişkiler yin-yang dengesi olarak görülür. {{soru}} konusunda bu ilişkide denge var mı? Biri çok veriyor, biri çok alıyor mu?\n\nDengeli ilişki her ikisinin de hem verdiği hem aldığı ilişkidir. Bu dengeyi konuşun — şikâyet etmeden, suçlamadan. 'Ben şunu hissediyorum' diye başlayın. O cümle çatışmayı diyaloğa dönüştürür.",
    tema: "denge"
  },
  {
    id: "imec005",
    metin: "{{ad}}, Japonya'da bir bilge şöyle derdi: 'En güçlü ilişkiler fırtınada test edilir.' {{soru}} konusunda bu ilişki fırtına geçirdi mi? Geçirdiyse ve hâlâ ayaktaysalar — bu çok güçlü bir temel demek.\n\nFırtınanın ardından gelen sükunet, fırtına öncesinden çok daha derindir. Zor dönemleri birlikte atlatmış çiftlerde özel bir bağ oluşur. O bağı kutlayın.",
    tema: "guc"
  },
  {
    id: "imec006",
    metin: "{{ad}}, Hindistan'da bir jyotishi şöyle derdi: 'İlişkideki sorunlar iki ruhun birbirine verdiği derslerdir.' {{soru}} konusunda bu iki insan birbirinden ne öğreniyor?\n\nHer anlaşmazlığın arkasında bir ders var. O dersi görmeye çalışın. 'Bu beni nasıl büyütüyor?' sorusu, 'bu neden böyle?' sorusundan çok daha güçlü bir kapı açar.",
    tema: "ders"
  },
  {
    id: "imec007",
    metin: "{{ad}}, Peru'da bir şaman şöyle derdi: 'İlişki canlı bir varlıktır — beslenmezse solar.' {{soru}} konusunda bu ilişki besleniyor mu? Zaman mı verilmiyor, ilgi mi azaldı, iletişim mi kesildi?\n\nHangi alan ihmal edilmiş? Onu tespit edin ve oraya odaklanın. İlişkiye verilen özen, alınan karşılıktan çok daha önemlidir. Verin — karşılık kendiliğinden gelir.",
    tema: "beslenme"
  },
  {
    id: "imec008",
    metin: "{{ad}}, Brezilya'da bir usta şöyle derdi: 'Aşk duygu değil, seçimdir.' {{soru}} konusunda her gün yeniden seçiliyor mu bu ilişki?\n\nSeçilmeyen ilişki yavaş yavaş solar. Bugün bilinçli bir seçim yapın — 'bu insanı, bu ilişkiyi seçiyorum' deyin içinizden. Sonra o seçime uygun davranın. Seçim eylemi doğurur.",
    tema: "secim"
  },
  {
    id: "imec009",
    metin: "{{ad}}, Marakeş'te bir bilge şöyle derdi: 'İletişim ilişkinin kanıdır — kesilirse ölür.' {{soru}} konusunda iletişim nasıl? Gerçek mi, yüzeysel mi?\n\nYüzeysel sohbet 'nasılsın, iyiyim'den öteye geçmez. Gerçek iletişim 'seni neyin üzdüğünü bilmek istiyorum' der. Bu farkı yaratın. Derinlemesine bir konuşma yapın — bugün.",
    tema: "iletisim"
  },
  {
    id: "imec010",
    metin: "{{ad}}, Tibet'te bir lama şöyle derdi: 'İki insan arasındaki sessizlik ilişkinin sağlığını gösterir.' {{soru}} konusunda bu sessizlik huzurlu mu, gergin mi?\n\nHuzurlu sessizlik derin bağın işareti — kelime gerekmeden anlaşmak. Gergin sessizlik ise çözülmemiş sorunların biriktiği bir depo. Hangisi bu? Buna göre adım atın.",
    tema: "sessizlik"
  },
  {
    id: "imec011",
    metin: "{{ad}}, Arjantin'de bir psikolog şöyle derdi: 'Güven yıllar içinde inşa edilir, saniyeler içinde yıkılır.' {{soru}} konusunda güven durumu nedir?\n\nEğer güven sarsılmışsa — onarılabilir, ama zaman ve sabır ister. Onarım süreci acıtır, ama onarılmış güven çok daha sağlamdır. Başlamak için çok geç değil.",
    tema: "guven"
  },
  {
    id: "imec012",
    metin: "{{ad}}, Yunanistan'da antik bir bilge şöyle demişti: 'En büyük cesaret sevmektir.' {{soru}} konusunda bu iki insan birbirini sevmek için yeterince cesur mu?\n\nAşk kırılgan olmayı, görülmeyi, reddedilme riskini almayı gerektirir. Bu cesaret kolay değil. Ama cesaretsiz aşk yüzeyde kalır — derine inemez. Cesur olun.",
    tema: "cesaret"
  },
  {
    id: "imec013",
    metin: "{{ad}}, Mısır'da bir bilge şöyle derdi: 'İlişki iki nehrin birleşmesidir — her biri kendi karakterini korur ama birlikte daha güçlüdür.' {{soru}} konusunda bireysellik korunuyor mu?\n\nBirbirinde eriyip kaybolmak aşk değil, bağımlılıktır. Bireyselliği koruyarak birlik sağlamak — işte gerçek aşk bu. Her biri kendi kişiliğiyle güçlü, birlikte ise daha güçlü.",
    tema: "bireysellik"
  },
  {
    id: "imec014",
    metin: "{{ad}}, Japonya'da 'kintsugi' sanatı var — kırık çanakları altınla onarma. Kırık yerler zayıflık değil, güzellik olur. {{soru}} konusunda bu ilişkide kırıklar var mı?\n\nVarsa — altınla onarın. O kırık yerler ilişkiyi zayıflatmaz, derinleştirir. 'Biz bu kırıklığı atlattık' diyebilmek, çok güçlü bir bağ yaratır.",
    tema: "onarma"
  },
  {
    id: "imec015",
    metin: "{{ad}}, Hindistan'da bir bilge şöyle derdi: 'İlişkide en tehlikeli şey rutindir.' {{soru}} konusunda rutin mi egemen olmuş?\n\nRutin güven verir ama heyecanı öldürür. İkisini bir arada tutmak mümkün — güvenli ama heyecanlı. Bu haftasonunu farklı geçirin. Küçük bir değişiklik büyük bir taze nefes getirir.",
    tema: "rutin"
  },
  {
    id: "imec016",
    metin: "{{ad}}, Çin felsefesinde 'wu wei' — zorlamasız eylem — ilişkilere de uygulanır. {{soru}} konusunda çok zorluyor musunuz birbirinizi?\n\nKontrol etmeyi bırakın, güvenin. Su kayaya zorlamaz — ama zamanla şekillendirir. Sevgi de böyledir. Yönlendirin, zorlayın değil. Bırakın, güvenin.",
    tema: "birakma"
  },
  {
    id: "imec017",
    metin: "{{ad}}, Brezilya'da bir şaman şöyle derdi: 'Affetmek zinciri kırmaktır — hem affedilen hem affeden özgür olur.' {{soru}} konusunda affedilmesi gereken bir şey var mı?\n\nAffetmek için özür beklemeyin. Kendi özgürlüğünüz için affetmeyi seçin. Affetmek unutmak değil — ilerlemek için geçmişi bırakmaktır. O yük her ikisini de ağır bastırıyor.",
    tema: "affetme"
  },
  {
    id: "imec018",
    metin: "{{ad}}, Peru'da bir usta şöyle derdi: 'İlişkide en önemli kelime biz'dir.' {{soru}} konusunda 'ben' mi 'biz' mi baskın?\n\nBen odaklı ilişki tükenir, biz odaklı ilişki büyür. Küçük bir dil değişikliği deneyin — 'sen yaptın' yerine 'biz bunu nasıl çözeriz?' deyin. Aynı sorun, çok farklı bir atmosfer.",
    tema: "birliktelik"
  },
  {
    id: "imec019",
    metin: "{{ad}}, Tibet'te bir lama şöyle derdi: 'En derin aşk beklentisiz aşktır.' {{soru}} konusunda beklentiler ilişkiye yük bindiriyor mu?\n\nBeklentileri konuşun — söylenmemiş beklentiler kırgınlığa dönüşür. 'Senden şunu bekliyorum' demek ilişkiyi zayıflatmaz, güçlendirir. Şeffaflık en sağlam temeli oluşturur.",
    tema: "beklenti"
  },
  {
    id: "imec020",
    metin: "{{ad}}, Marakeş'te bir usta şöyle derdi: 'İki insan ne kadar farklı olursa, o kadar çok birbirinden öğrenebilir.' {{soru}} konusunda farklılıklar sorun mu, zenginlik mi?\n\nBakış açısı her şeyi değiştirir. Farklılıkları tehdit olarak değil, genişleme fırsatı olarak görün. Karşınızdaki size görmediğiniz bir pencere açıyor — o pencereden bakın.",
    tema: "farklilik"
  },
  {
    id: "imec021",
    metin: "{{ad}}, Yunanistan'da Aristoteles şöyle demişti: 'Aşk iki bedende yaşayan tek ruhtur.' {{soru}} konusunda bu iki insan o birliği hissediyor mu?\n\nHissetmiyorlarsa — o birliği yeniden inşa etmek mümkün. Ama ikisi de istemeli. İstek ortak olduğunda, yol kendiliğinden açılır.",
    tema: "birlik"
  },
  {
    id: "imec022",
    metin: "{{ad}}, Hindistan'da bir jyotishi şöyle derdi: 'İlişkinin enerjisi her iki kişinin enerjisinin toplamından büyüktür.' {{soru}} konusunda bu sinerji var mı?\n\nBirlikte ayrı ayrı olduklarından daha güçlü mü hissediyorlar? Bu sorunun cevabı çok şey anlatır. Eğer cevap evet ise — o sinerjyi besleyin. Hayır ise — neyin eksik olduğunu bulun.",
    tema: "sinerji"
  },
  {
    id: "imec023",
    metin: "{{ad}}, Japonya'da bir bilge şöyle derdi: 'İlişkide büyümek için önce bireysel olarak büyümek gerekir.' {{soru}} konusunda her biri kendi gelişimine vakit ayırıyor mu?\n\nBireysel büyüme ilişkiyi zenginleştirir. Kendine yatırım yapan insan, ilişkisine de yatırım yapmış olur. Kendi gelişiminizi ihmal etmeyin — ilişkiniz bundan beslenir.",
    tema: "bireysel_buyume"
  },
  {
    id: "imec024",
    metin: "{{ad}}, kırk yılda öğrendim: her ilişki kendi dilini yaratır — o dili sadece o iki insan anlar. {{soru}} konusunda bu iki insanın kendi dili var mı?\n\nOrtak şakalar, ortak anılar, ortak kelimeler — bunlar ilişkiyi özel kılan şeylerdir. Eğer o dil zayıflamışsa, yeniden yaratın. Bugün yeni bir ortak an oluşturun.",
    tema: "ortak_dil"
  },
  {
    id: "imec025",
    metin: "{{ad}}, kırk ülkede gördüğüm ilişkilerden öğrendim: en güzel ilişkiler mükemmel değil, gerçektir. {{soru}} konusunda mükemmelliği bırakın, gerçekliği kucaklayın.\n\nKusurlarıyla, güzellikleriyle, zorluklarıyla — gerçek ilişki budur. Ve bu yeterince güzel. Sahip olduğunuzu görün. Mükemmeli ararken gerçeği kaybetmeyin.",
    tema: "gerceklik"
  }
];